import { render, staticRenderFns } from "./PaymentsUserDefinedField.vue?vue&type=template&id=ebed9a06&"
import script from "./PaymentsUserDefinedField.vue?vue&type=script&lang=js&"
export * from "./PaymentsUserDefinedField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports